import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const patternMakerModule = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    currentPattern: {},
    selectedSwatch: {},
    selectedSticker: {},
    selectedStyle: null,
    navigation: {
      activeView: "",
      activeViewIndex: 0,
      views: [],
    },
    previewImage: {
      dataIsReady: false,
      id: null,
      url: null,
    },
    activeUGCComponent: null,
    orderStyles: [],
    selectableStyles: [],
    highligthSelectSwatchInstructions: false,
    highligthSelectStickerInstructions: false,
    isCreatingAssets: false,
    useSvgRenderer: false,
    source: ''
  }
};

export default patternMakerModule;
